module.exports = __webpack_public_path__ + "static/media/Profile-white.de3408bb.svg";